<div> Name : {{element.name}}</div>
<div> Type : {{element.type}}</div>
<div> Application : {{element.application}}</div>
<div> Number : {{element.number}}</div>

<div class="text-right">
  <a (click)="close()">Close</a>
</div>
